import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import * as XLSX from 'xlsx';

import axios from "src/app/Service/axios";
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

@Component({

  selector: 'app-buffet-sales-report',

  templateUrl: './buffet-sales-report.component.html',

  styleUrls: ['./buffet-sales-report.component.css']

})

export class BuffetSalesReportComponent implements OnInit {

  list_Sold: any = [];

  list_search: any = [];

  isLoading: boolean = false;

  totalPrice: number = 0;

  dateFilter: FormGroup = this.FormBuilder.group({

    strSDate: new FormControl(''),

    strEDate: new FormControl('')

  })

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {
  }

  goBack() {

    this.router.navigate(['/'])

  }

  async search_SoldBuffet() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strSDate: this.dateFilter.value.strSDate,

      strEDate: this.dateFilter.value.strEDate,

    }

    let res = JSON.parse((await axios.post(`Buffet_ReportSale`, model)).data.toString());

    this.isLoading = false;

    this.list_Sold = res;

    this.list_Sold.forEach((a: any) => {

      this.totalPrice += a.iPrice;
    })

    this.list_search = res;

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Sold = this.list_search.filter((el: any) => {

        return el.strTitle.includes(search);

      })
    }

    else if (search == '') this.list_Sold = this.list_search;

    this.totalPrice = 0;

    this.list_Sold.forEach((a: any) => {

      this.totalPrice += a.iPrice;

    })

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'گزارش فروش.xlsx');

    }, 200);

  }

}
